// extracted by mini-css-extract-plugin
module.exports = {"footer":"StoreFooter_footer__1I4Bh","signUpBtn":"StoreFooter_signUpBtn__3AfQJ"};
    if(module.hot) {
      // 1686459237929
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  